import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import CloseIcon from "@mui/icons-material/Close";
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CustomButton from "../common/CustomButton";
import CircularProgress from "@mui/material/CircularProgress";

import "./DialogConformationMsg.sass";

function DialogConformationMsg({
  open,
  handleClose,
  dialogTitle,
  dialogContentText,
  handleConfirm,
  cancel = "Cancel",
  confirm = "Confirm",
  startIcon,
  confirmDisabled = false,
  confirmLoading = false,
}) {
  const resolvedStartIcon = confirmLoading ? (
    <CircularProgress size={16} color="inherit" />
  ) : (
    startIcon
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ className: "dialog" }}>
      <DialogTitle className="dialog-title">
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar className="dialog-avatar">
            <WarningAmberIcon fontSize="small" />
          </Avatar>
          <Typography variant="h6" className="dialog-title-text">
            {dialogTitle}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent className="dialog-content">
        <DialogContentText>{dialogContentText}</DialogContentText>
      </DialogContent>

      <DialogActions className="dialog-action">
        <CustomButton datatestid={"custom-left-button"} onClick={handleClose} size="small" btnType="nonary" className="custom-cancel">
          {cancel}
        </CustomButton>
        <CustomButton
          datatestid={`custom-right-button-${confirm}`}
          onClick={handleConfirm}
          size="small"
          className="custom-confirm"
          btnType="nonary"
          startIcon={resolvedStartIcon}
          disabled={confirmDisabled || confirmLoading}
        >
          {confirm}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}

export default DialogConformationMsg;